<template>
  <div class="py-4 container-fluid">
    <div class="card shadow-lg mt-n4">
      <div class="card-body p-3">
        <!-- Header con titolo e bottone aggiungi -->
        <div class="row align-items-center mb-3">
          <!-- Titolo a sinistra -->
          <div class="col-lg-9 col-md-8 col-sm-12">
            <header-title :title="'Lista clienti'"></header-title>
          </div>
          
          <!-- Bottone Aggiungi a destra -->
          <div class="col-lg-3 col-md-4 col-sm-12 text-end">
            <button
              class="btn btn-outline-warning btn-sm"
              @click="addCustomer()"
            >
              <i class="fa fa-plus me-1"></i> Aggiungi
            </button>
          </div>
        </div>

        <!-- Form di ricerca -->
        <div class="row">
          <div class="col-12">
            <vee-form @submit="searchCustomer">
              <div class="d-flex gap-2 align-items-center">
                <vee-field 
                  type="text" 
                  name="cerca" 
                  class="form-control form-control-sm flex-grow-1" 
                  placeholder="Cerca cliente..."
                />
                <argon-button
                  size="sm"
                  variant="gradient"
                  color="primary"
                >
                  Cerca
                </argon-button>
              </div>
            </vee-form>
          </div>
        </div>
      </div>
    </div>
  </div>
 
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <customer-table :customers="customers" v-if="this.customers && !this.search_customer"/>
        <div v-if="total > pagination_size" class="col-12">
          <app-pagination
            :total-items="total"
            :items-per-page="pagination_size"
            @getPaginationItems="getPaginationCustomers"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import ArgonButton from "@/components/ArgonButton.vue";
import AppPagination from "@/components/Pagination.vue";
import { setItem, getItem } from "@/utility/localStorageControl";
import HeaderTitle from "@/components/Header/HeaderTitle.vue";
import CustomerTable from "@/views/customer/customerTable.vue";

export default {
  name: "list-customer",
  components: {
    HeaderTitle,
    CustomerTable,
    AppPagination,
    ArgonButton,
  },
  data() {
    return {
      customers: null,
      search_customer: false,
      pages: 0,
      total: 0,
      pagination_size: 1,
    };
  },
  mounted() {
    this.getCustomers();
  },
  methods: {
    async getCustomers() {
      try {
        const response = await axios.get(this.$endpoint + "/customer/list", {
          params: {
            page: 1,
            size: this.pagination_size,
          },
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        });

        this.customers = response.data.data;
        this.total = response.data.total;
        this.pages = response.data.pages;
      } catch (ex) {
        console.log(ex);
      }
    },
    addCustomer() {
      router.push({ name: "Modifica cliente" });
    },
    async searchCustomer(searchValue) {
      let loader;
      try {
        loader = this.$loading.show({
          loader: "dots",
          color: "#2dce89",
        });
        this.search_customer = true;
        
        const response = await axios.get(this.$endpoint + "/customer/list", {
          params: { search: searchValue.cerca },
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        });
        
        this.customers = response.data.data;
        this.search_customer = false;

        setItem("search_customer", searchValue.cerca);
        loader.hide();
      } catch (ex) {
        console.log(ex);
        loader?.hide(); // Nascondi il loader anche in caso di errore
      }
    },
    async getPaginationCustomers(page) {
      try {
        let searchDataInStore = await getItem("search_customer");
        const response = await axios.get(this.$endpoint + "/customer/list", {
            params: {
              page: page,
              size: this.pagination_size,
              search: searchDataInStore || '',
            },
            headers: {
              authorization: process.env.VUE_APP_APY_KEY,
            },
          }
        );
        this.customers = response.data.data;
        this.total = response.data.total;
      } catch (ex) {
        console.log(ex);
      }
    },
  },
};
</script>

<style>
ul li input[type="text"] {
  display: block;
}

.search-field {
  display: inline;
  width: 85%;
  padding: 0.5rem 0.75rem;
  margin-right: 0.5rem;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 0.8rem;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d2d6da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.5rem;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.text-right {
  text-align: right;
}
</style>
